<template>
    <div class="col-12 col-md-12 col-lg-10 col-xl-10" >
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-10 col-xl-10">
                <div class="tit text-center">
                    <img src="/static/assets/images/ico-file.svg" style="margin-bottom:40px; width:60px;" alt="icone arquivo">
                    <h1>Confirmação do seu Perfil de Investimento</h1>
                    <p>Se houver diferença entre o nível de capacidade de risco (item 1) e tolerância ao risco (item 2), o menor resultado entre eles será considerado como o seu Perfil de Risco.</p>
                </div>

                <form @submit="onSubmit">
                    <div class="card" style="width: 30rem; margin:0 auto 30px auto;">
                        <div class="card-body text-center">
                            <p class="card-text">Confirmo que as informações fornecidas são verdadeiras e que devo atualizá-las caso haja alterações e sempre que for solicitado.</p>

                            <div class="form-check d-flex justify-content-center">
                                <div class="checkboxContainer">
                                 <input type="checkbox" class="form-check-input" id="chkAceite" v-model="Aceite">
                                 <span class="checkmark"></span>
                                </div>
                                <div>
                                    <label class="form-check-label" for="chkAceite"><strong>ACEITAR</strong></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center fixedOptions">
                        <form @submit="onSubmit">
                            <button class="btn btn-lg btn-primary" :disabled="verificaPreenchimento()">Submeter respostas <i class="fas fa-check"></i></button>
                        </form>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/styles/iouu/_mixins.scss';

    @include mob {
        .card {
            width: 100% !important;
        }
    }
</style>



<script>
    export default {
    data() {
        const Aceite = this.suitability.Aceite
        return {
        Aceite: Aceite 
        }
    },
  props: {
    suitability: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      this.$emit('on-submit', {
        Aceite:  this.Aceite
      })
    },
    verificaPreenchimento(){
     
     return this.Aceite != true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InformationSuitability/AceiteConfirmacao.vue